<script>
import feather from 'feather-icons';

export default {
  name: 'Home',
  data: () => {
    return {
      theme: '',
      typeText: '',
      currentRole: 0,
      roles: ['Software Engineer', 'Software Designer'], 
      showRole: '',
      isTypingRole: false,
      currentRoleText: ''
    };
  },
  created() {
    this.theme = localStorage.getItem('theme') || 'light';
  },
  mounted() {
    feather.replace();
    this.theme = localStorage.getItem('theme') || 'light';
    
    // Start typing animation for name
    this.typeWriter("I'M M ZAIN UL ABIDEEN", 100);
    
    // Start role typing animation
    setTimeout(() => {
      this.typeNextRole();
    }, 1500);
    
    // Add animation class to the paragraph after a delay
    setTimeout(() => {
      this.$refs.descriptionParagraph.classList.add('animate-fade-in');
    }, 2000);
  },
  updated() {
    feather.replace();
  },
  methods: {
    typeWriter(text, speed) {
      let i = 0;
      const vm = this;
      
      function type() {
        if (i < text.length) {
          // Special handling for the apostrophe with color
          if (text.charAt(i) === "'") {
            vm.typeText += "<span style=\"color: #a72128\">'</span>";
          } else {
            vm.typeText += text.charAt(i);
          }
          i++;
          setTimeout(type, speed);
        }
      }
      
      type();
    },
    typeNextRole() {
      const currentRole = this.roles[this.currentRole];
      this.isTypingRole = true;
      this.currentRoleText = '';
      
      let i = 0;
      const typeRoleChar = () => {
        if (i < currentRole.length) {
          this.currentRoleText += currentRole.charAt(i);
          i++;
          setTimeout(typeRoleChar, 50);
        } else {
          // Wait for a while with the completed text
          setTimeout(() => {
            // Erase the text
            this.eraseRole(() => {
              // Move to next role
              this.currentRole = (this.currentRole + 1) % this.roles.length;
              // Wait a bit before typing next role
              setTimeout(() => {
                this.typeNextRole();
              }, 500);
            });
          }, 1500);
        }
      };
      
      typeRoleChar();
    },
    eraseRole(callback) {
      const eraseChar = () => {
        if (this.currentRoleText.length > 0) {
          this.currentRoleText = this.currentRoleText.slice(0, -1);
          setTimeout(eraseChar, 40); // Erase faster than typing
        } else {
          callback();
        }
      };
      
      eraseChar();
    }
  }
};
</script>

<template>
  <section class="flex flex-col sm:justify-between items-center sm:flex-row mt-20 sm:mt-16">
    <!-- Banner left contents -->
    <div class="w-full md:w-2/3 text-left text-display-div">
      <h1 class="typing-text" v-html="typeText"></h1>
      
      <p class="font-general-medium mt-2 text-lg sm:text-xl xl:text-3xl text-center sm:text-left leading-none roles_text font-bold">
        {{ currentRoleText }}<span class="typing-cursor" v-if="isTypingRole">|</span>
      </p>
      <p ref="descriptionParagraph" class="mt-5 mr-28 description-text">
        Fascinated by technology since childhood, I was drawn to video games and curious about how they worked. This curiosity sparked a passion for coding, propelling me into software development. Thrilled by continuous learning, I'm dedicated to creating solutions and embracing new challenges in the tech world.
      </p>
      <div class="flex justify-center sm:block mt-4">
        <a download="Zain-Resume.pdf" href="/files/Zain-Resume.pdf" class="button-3" aria-label="Download Resume">
          <i data-feather="arrow-down-circle" class="ml-0 sm:ml-1 mr-2 sm:mr-3 w-5 sm:w-6 duration-100"></i>
          <span class="text-sm sm:text-lg font-general-medium duration-100">Download CV</span>
        </a>
      </div>
    </div>

    <!-- Banner right illustration -->
    <div class="w-full md:w-1/3 text-right float-right relative">
      <div class="glass-effect glass-effect-1"></div>
      <div class="glass-effect glass-effect-2"></div>
      <img src="@/assets/images/developer.png" alt="Developer" class="w-full h-auto relative z-10 banner-img" />
    </div>
  </section>
</template>

<style scoped>
.glass-effect {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 4rem;
}

.glass-effect-1 {
  transform: rotate(-14deg);
}

.glass-effect-2 {
  transform: rotate(-7deg);
}

.banner-img {
  border-radius: 4rem;
}

/* Typing animation styles */
.typing-text {
  min-height: 1.5em;
}

/* Typing cursor animation */
.typing-cursor {
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  from, to { opacity: 1; }
  50% { opacity: 0; }
}

/* Description paragraph animation */
.description-text {
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.8s ease;
  font-weight: 200  ;
}

.animate-fade-in {
  opacity: 1;
  transform: translateY(0);
}
</style>